<template>
  <loginless-layout :title="$t('titles.forgottenPassword')">
    <template v-if="!sent">
      <form @submit.prevent="save">
        <v-alert error :value="!!error"><span v-html="error"></span></v-alert>

        <p class="my-4">{{ $t('forgotten.description') }}</p>

        <v-text-field
          v-model="username"
          hide-details
          :label="$t('headers.username')"
          :required="true"
        />

        <v-card-actions>
          <v-btn :loading="isBusy" type="submit">{{ $t('forgotten.send') }}</v-btn>
        </v-card-actions>
      </form>
    </template>
    <template v-else>
      <v-alert success value="true">{{ $t('forgotten.success') }}</v-alert>
    </template>
  </loginless-layout>
</template>

<script>
import LoginlessLayout from '@/components/LoginlessLayout'
import User from '@/models/User'

export default {
  props: ['token'],
  data () {
    return {
      isBusy: false,
      sent: false,
      error: null,
      username: null
    }
  },
  methods: {
    save () {
      this.isBusy = true

      User
        .requestReset(this.username)
        .then(() => {
          this.isBusy = false
          this.sent = true
        })
        .catch(err => {
          console.error(err)
          this.error = this.$t('forgotten.failed')
          this.isBusy = false
        })
    }
  },
  components: {
    LoginlessLayout
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ForgottenPassword.vue?a3a369c0